import { render } from "./brand_disable.vue?vue&type=template&id=4af1adce"
import script from "./brand_disable.vue?vue&type=script&lang=js"
export * from "./brand_disable.vue?vue&type=script&lang=js"

import exportComponent from "F:\\code\\ywym\\ydd-zht-web\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__